module.exports = __webpack_public_path__ + "static/media/logo-consulta.7f6c9f52.png";